__turbopack_context__.v({
  "fade-in": "Breadcrumbs-module-scss-module__mWWGwa__fade-in",
  "icon": "Breadcrumbs-module-scss-module__mWWGwa__icon",
  "isHidden": "Breadcrumbs-module-scss-module__mWWGwa__isHidden",
  "root": "Breadcrumbs-module-scss-module__mWWGwa__root",
});
